export default [
    {
        path: '/platinum/experience',
        props: true,
        component: () => import('@/views/PlatinumExperience'),
    },
];
